import { Link } from 'react-router-dom';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-primary-950 text-white py-12 border-t border-primary-900">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 text-center md:text-left">

                    <div className="col-span-1 md:col-span-1">
                        <div className="flex flex-col items-center mb-4">
                            <img
                                src="/images/logo-uta-light-2026.png"
                                alt="Logo UTA"
                                className="h-20 w-20 object-contain mb-3"
                            />
                            <h3 className="text-2xl font-serif font-bold text-center">UTA <span className="text-accent-500">Barvaux</span></h3>
                        </div>
                        <p className="text-primary-200">
                            Université de Tous Âges<br />
                            Nord-Luxembourg<br />
                            (Barvaux-sur-Ourthe)
                        </p>
                    </div>

                    <div>
                        <h4 className="font-bold text-lg mb-4 text-white">Navigation</h4>
                        <ul className="space-y-2">
                            <li><Link to="/" className="text-primary-200 hover:text-white transition-colors">Accueil</Link></li>
                            <li><Link to="/agenda" className="text-primary-200 hover:text-white transition-colors">Agenda</Link></li>
                            <li><Link to="/a-propos" className="text-primary-200 hover:text-white transition-colors">À propos</Link></li>
                            <li><Link to="/contact" className="text-primary-200 hover:text-white transition-colors">Contact</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold text-lg mb-4 text-white">Contact</h4>
                        <ul className="space-y-2 text-primary-200">
                            <li>Parc de Juliénas 1</li>
                            <li>6940 Barvaux-sur-Ourthe</li>
                            <li>daniellemottet47@gmail.com</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold text-lg mb-4 text-white">Légal</h4>
                        <ul className="space-y-2">
                            <li><Link to="/privacy" className="text-primary-200 hover:text-white transition-colors">Politique de confidentialité</Link></li>
                            <li><Link to="/admin/login" className="text-primary-200 hover:text-white transition-colors">Admin</Link></li>
                        </ul>
                    </div>

                </div>

                <div className="mt-12 pt-8 border-t border-primary-900 text-center text-primary-400 text-sm">
                    <p>© {currentYear} Université de Tous Âges Nord-Luxembourg (Barvaux-sur-Ourthe). Tous droits réservés.</p>
                    <p className="mt-2 text-primary-500 text-xs">
                        Site réalisé par <a href="https://www.deravet-digital.com" target="_blank" rel="noopener noreferrer" className="hover:text-primary-300 transition-colors">Deravet Digital</a>
                    </p>
                </div>
            </div>
        </footer>
    );
}
